import angular from 'angular';
import _ from 'underscore';
"use strict";
angular.module('emun.consumer').service('refundOrderPrompt', RefundOrderPromptFactory);

function RefundOrderPromptFactory(modals) {
    return {
        open(options) {
            return modals.open(angular.extend({
                size: 'md',
                placement: 'right',
                //backdrop: false,
                templateUrl: 'refund-order-prompt.html',
                resolve: {
                    options: () => options
                },
                controller: RefundOrderPromptController,
                controllerAs: '$ctrl'
            }, (options || {}).modal)).result;
        }
    };
}
function RefundOrderPromptController($rootScope, $uibModalInstance, createServiceBus, options) {
    var $ctrl = this;
    var model = $ctrl.model = options.model;
    var bus = $ctrl.bus = createServiceBus($rootScope);
    $ctrl.title = options.title || 'Refund Order...'

    $ctrl.save = $ctrl.submit = function () {
        bus.send('RefundCart.json', $ctrl.model).then(function (response) {
            $rootScope.$emit('orderRefunded', $ctrl);
            $uibModalInstance.close($ctrl.model);
        });
    };
    $ctrl.dismiss = function () {
        $uibModalInstance.dismiss();
    };
}